import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import useSpotlight from '../../hooks/useSpotlight';
import ReceiptLongOutlined from '@mui/icons-material/ReceiptLongOutlined';
import PeopleAltOutlined from '@mui/icons-material/PeopleAltOutlined';
import DescriptionOutlined from '@mui/icons-material/DescriptionOutlined';
import PaymentsOutlined from '@mui/icons-material/PaymentsOutlined';
import LocalShippingOutlined from '@mui/icons-material/LocalShippingOutlined';
import ShoppingCartOutlined from '@mui/icons-material/ShoppingCartOutlined';
import SellOutlined from '@mui/icons-material/SellOutlined';
import BarChartOutlined from '@mui/icons-material/BarChartOutlined';
import AddShoppingCartOutlined from '@mui/icons-material/AddShoppingCartOutlined';
import PlaylistAddOutlined from '@mui/icons-material/PlaylistAddOutlined';
import MoveToInboxOutlined from '@mui/icons-material/MoveToInboxOutlined';
import OutboxOutlined from '@mui/icons-material/OutboxOutlined';

const ICONS = {
  expense: ReceiptLongOutlined,
  clients: PeopleAltOutlined,
  billing: DescriptionOutlined,
  payments: PaymentsOutlined,
  suppliers: LocalShippingOutlined,
  purchases: ShoppingCartOutlined,
  priceList: SellOutlined,
  reports: BarChartOutlined,
  singlePurchase: AddShoppingCartOutlined,
  bulkPurchase: PlaylistAddOutlined,
  emptyLoad: MoveToInboxOutlined,
  emptyReturn: OutboxOutlined,
};

// size: 'compact' (default), 'featured' (ocupa dos columnas, con "Más usado") o 'large' (más grande, ej. pantallas de selección).
export default function AccessCard({ title, description, url, icon, size = 'compact' }) {
  const navigate = useNavigate();
  const cardRef = useRef(null);

  useSpotlight(cardRef);

  const Icon = ICONS[icon];
  const isFeatured = size === 'featured';
  const isLarge = size === 'large';

  return (
    <button
      ref={cardRef}
      type="button"
      onClick={() => navigate(url)}
      style={{ transform: 'perspective(800px) rotateX(var(--rx, 0deg)) rotateY(var(--ry, 0deg))' }}
      className={`group relative flex w-full cursor-pointer flex-col items-start justify-between rounded-2xl border border-border-subtle bg-access-card text-left ${isLarge ? 'gap-4 p-5 sm:p-6' : 'gap-1 p-3'} transition-[border-color,box-shadow] duration-200 hover:border-accent/50 hover:shadow-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent ${isFeatured ? 'sm:col-span-2' : ''}`}
    >
      <span
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 rounded-2xl opacity-0 transition-opacity duration-200 group-hover:opacity-100"
        style={{
          background: 'radial-gradient(220px circle at var(--mx, 50%) var(--my, 50%), rgb(var(--color-accent-rgb) / 0.16), transparent 65%)',
        }}
      />
      <span className="relative flex flex-col items-start gap-1">
        {Icon && (
          <span className={`flex items-center justify-center rounded-xl bg-accent/15 text-accent ${isLarge ? 'h-11 w-11' : 'h-8 w-8'} ${isFeatured ? 'sm:h-9 sm:w-9' : ''}`}>
            <Icon fontSize={isLarge ? 'medium' : 'small'} />
          </span>
        )}
        {isFeatured && (
          <p className="hidden text-[10px] font-bold uppercase tracking-wider text-accent sm:block">Más usado</p>
        )}
      </span>
      <span className="relative">
        <h2 className={`font-semibold text-on-surface ${isLarge ? 'text-base sm:text-lg' : 'text-sm'} ${isFeatured ? 'sm:text-base' : ''}`}>{title}</h2>
        <p className={`text-on-surface-muted ${isLarge ? 'mt-1 text-sm' : 'text-xs'}`}>{description}</p>
      </span>
    </button>
  );
}
